import Vue from 'vue'
import Vuex from 'vuex'
import {auth} from './modules/auth.module'
import {constructor} from './modules/constructor.module'
import {directorio} from './modules/directorio.module'
import {recursos} from './modules/recursos.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    constructor,
    directorio,
    recursos
  },
  state: {
    
  },
  mutations: {

  },
  actions: {

  }
})
